<template>
  <AdPageUnavailable :path="['decor.scenarios', 'decor.scenarios.scenarios']">
    <v-layout>
      <v-flex>
        <ScenarioPanel/>
      </v-flex>
    </v-layout>
  </AdPageUnavailable>
</template>

<script>

import ScenarioPanel from '@/components/Scenario/ScenarioPanel'

export default {
  name: 'AdScenario',
  components: {
    ScenarioPanel
  },
  beforeRouteLeave (to, from, next) {
    const exceptions = ['scenarioItems', 'actors']
    const scenarioItemsLoaded = this.$store.state.scenario.loaded.scenarioItems
    const actorsLoaded = this.$store.state.scenario.loaded.actors
    this.$store.commit('scenario/initScenario', exceptions)
    this.$store.commit('scenario/setLoaded', { key: 'scenarioItems', status: scenarioItemsLoaded })
    this.$store.commit('scenario/setLoaded', { key: 'actors', status: actorsLoaded })
    next()
  }

}
</script>
